import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../lib/utils';
const badgeVariants = cva('inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2', {
  variants: {
    variant: {
      default: 'border-transparent bg-primary-600 text-white hover:bg-primary-700',
      secondary: 'border-transparent bg-gray-100 text-gray-700 hover:bg-gray-200',
      destructive: 'border-transparent bg-red-600 text-white hover:bg-red-700',
      outline: 'text-gray-700 border-gray-300 bg-white',
      success: 'border-transparent bg-green-100 text-green-800 hover:bg-green-200',
      warning: 'border-transparent bg-amber-100 text-amber-800 hover:bg-amber-200',
      info: 'border-transparent bg-blue-100 text-blue-800 hover:bg-blue-200'
    }
  },
  defaultVariants: {
    variant: 'default'
  }
});
export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {
  dot?: boolean;
  pulse?: boolean;
}
function Badge({
  className,
  variant,
  dot,
  pulse,
  children,
  ...props
}: BadgeProps) {
  return <div className={cn(badgeVariants({
    variant
  }), className)} {...props} data-id="element-273">
      {dot && <span className={cn('mr-1.5 h-2 w-2 rounded-full', pulse && 'animate-pulse', variant === 'default' && 'bg-white', variant === 'secondary' && 'bg-gray-600', variant === 'destructive' && 'bg-white', variant === 'outline' && 'bg-gray-500', variant === 'success' && 'bg-green-600', variant === 'warning' && 'bg-amber-600', variant === 'info' && 'bg-blue-600')} data-id="element-274" />}
      {children}
    </div>;
}
export { Badge, badgeVariants };